import { createStyles, makeStyles } from '@material-ui/core';
import { Theme } from '@mui/material';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        plannedOnWrapper: {
            display: 'flex',
            alignItems: 'center',
            fontSize: 'small',
        },
        formWrapper: {
            padding: theme.spacing(2),
        },
        iconButton: {
            height: 30,
            width: 30,
            padding: 0,
        },
        iconButtonIcon: {
            height: 25,
            width: 25,
        },
        listItem: {
            fontSize: theme.typography.caption.fontSize,
            justifyContent: 'space-between',
            borderTop: '1px solid ' + theme.palette.divider,
            color: theme.palette.primary.dark,
        },
        secondaryAction: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            width: '60%',
            wordWrap: 'break-word',
            textAlign: 'right',
        },
        photoContainer: {
            width: '100%',
            position: 'relative',
            '&:hover $photoOverlay > button:first-child': {
                display: 'block',
            },
        },
        list: {
            marginTop: theme.spacing(),
        },
        listItemHeading: {
            paddingLeft: theme.spacing(2),
            paddingBottom: 0,
            paddingTop: 0,
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.grey[200],
        },
        itemValue: {
            fontSize: theme.typography.caption.fontSize,
            width: '100%',
            textAlign: 'right',
        },
        itemLabel: {
            fontFamily: 'OpenSans-Regular',
            fontSize: theme.typography.caption.fontSize,
            paddingRight: theme.spacing(),
            fontWeight: 'bold',
            wordWrap: 'break-word',
            width: '40%',
            display: 'contents',
        },
    })
);
